var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorInput(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 2a9.667 9.667 0 100 19.333 9.667 9.667 0 000-19.333zm0 17.722a8.055 8.055 0 110-16.11 8.055 8.055 0 010 16.11z",
    fill: "#DB4957"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 13.333a.996.996 0 01-.707-.295 1.012 1.012 0 01-.293-.712V7.674c0-.267.105-.523.293-.712a.996.996 0 011.414 0c.187.189.293.445.293.712v4.652c0 .267-.106.523-.293.712a.996.996 0 01-.707.295zM11.667 16.667a1 1 0 100-2 1 1 0 000 2z",
    fill: "#DB4957"
  })));
}

export default SvgErrorInput;